import React, { ReactNode } from "react";
import { Action, ApplicationState } from "./types";
import { useUserAccess } from "context/UserAccessContext";
import { isActionAllowed } from "./permissionUtils";

interface PermissionWrapperProps {
  actions: Action | Action[]; // Single or multiple actions
  children: ReactNode | ((props: { isAllowed: boolean }) => ReactNode);
  fallback?: ReactNode;
  applicationStatus?: ApplicationState;
  productType?: string;
}

const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  actions,
  children,
  fallback = null,
  applicationStatus,
  productType,
}) => {
  const { role } = useUserAccess();
  const actionsArray = Array.isArray(actions) ? actions : [actions];

  // Check permissions:
  const isAllowed = actionsArray.some((action) => {
    // Allow based on role only if applicationStatus is not provided
    if (!applicationStatus) {
      return isActionAllowed(role, null, action, productType);
    }
    // Otherwise, check both role and applicationState
    return applicationStatus
      ? isActionAllowed(role, applicationStatus, action, productType)
      : false;
  });

  if (typeof children === "function") {
    return <>{children({ isAllowed })}</>;
  }

  return isAllowed ? <>{children}</> : <>{fallback}</>;
};

export default PermissionWrapper;
